@let icon = markerIcon();
@let isSmall = small();

<div class="flex items-center gap-3">
  <div class="size-[2.75rem] rounded-lg bg-(--p-neutral-500) flex items-center justify-center shrink-0"
       [ngClass]="{ '!size-[2.25rem]': isSmall }">
    <svg-icon [src]="icon.src"
              [name]="icon.name ?? icon.src"
              class="flex original-icon shrink-0"
              [svgClass]="'!size-[1.125rem]'"></svg-icon>
  </div>

  @if (isAiPredictor()) {
    <gc-ld-logger-noise-score-ai-predictor
      [leakScore]="leakScore()"
      [leakScoreStatus]="leakScoreStatus()"
      [small]="isSmall">
    </gc-ld-logger-noise-score-ai-predictor>
  } @else {
    <gc-ld-logger-noise-score-leak
      [leakScore]="leakScore()"
      [leakScoreStatus]="leakScoreStatus()"
      [small]="isSmall">
    </gc-ld-logger-noise-score-leak>
  }
</div>
